import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {GoogleAnalyticsEventDetails} from '../../models/google-analytics-event-details';
import {Serialize} from 'cerialize';

declare var gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor(private router: Router) {
  }

  public event(eventName: string, params: {}): void {
    gtag('event', eventName, params);
  }

  public init(): void {
    this.listenForRouteChanges();

    try {
      // google consent mode script for cookieyes
      const gcmScript = document.createElement('script');
      gcmScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag("consent", "default", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied",
          functionality_storage: "denied",
          personalization_storage: "denied",
          security_storage: "granted",
          wait_for_update: 500,
        });
        gtag("set", "ads_data_redaction", true);
        gtag("set", "url_passthrough", true);
      `;
      document.head.appendChild(gcmScript);

      const remoteGaLibraryReference = document.createElement('script');
      remoteGaLibraryReference.async = true;
      remoteGaLibraryReference.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.googleAnalyticsKey;
      document.head.appendChild(remoteGaLibraryReference);

      const localGaConfigScript = document.createElement('script');
      localGaConfigScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '` + environment.googleAnalyticsKey + `', {'send_page_view': false});
      `;
      document.head.appendChild(localGaConfigScript);

      const cookieYesReference = document.createElement('script');
      cookieYesReference.id = 'cookieyes';
      cookieYesReference.type = 'text/javascript';
      cookieYesReference.src = 'https://cdn-cookieyes.com/client_data/' + environment.cookieYesKey + '/script.js';
      document.head.appendChild(cookieYesReference);

    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }

  private listenForRouteChanges(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', environment.googleAnalyticsKey, {
          'page_path': event.urlAfterRedirects,
        });
        console.log('Sending Google Analytics hit for route', event.urlAfterRedirects);
      }
    });
  }

  public sendEvent(action: string, eventDetails: GoogleAnalyticsEventDetails = null): void {
    if (eventDetails) {
      gtag('event', action, Serialize(eventDetails));
      console.log('Sending Google Analytics bijbEvent', action, eventDetails);
    } else {
      gtag('event', action);
      console.log('Sending Google Analytics bijbEvent', action);
    }
  }
}
